import { withInstall } from '@sgui-plus/utils/with-install'

import Page from './src/page'

export const SgPage = withInstall(Page)
export default SgPage

export * from './src/page'
export * from './src/constants'
